import React, { FC } from 'react';

import { BaseInputProps } from '../typings/InputProps';

export const CheckboxInput: FC<BaseInputProps> = (props) => {
	return null;
};

export const Checkbox: FC<{
	checkboxObject: any;
	label?: string;
	componentId?: string;
}> = (props) => {
	return (
		<div data-selection={props.componentId} className="vtex-checkbox__line-container flex items-start relative pointer">
			<div className="vtex-checkbox__container relative w1 h1 mr3">
				<div
					className="vtex-checkbox__inner-container h1 w1 absolute ba bw1 br1  b--muted-4 pointer mr3"
					style={{ transition: 'background 20ms', border: '100ms' }}
				></div>
				<div className="vtex-checkbox__box-wrapper absolute w1 h1 flex o-100" style={{ left: '0' }}>
					<div
						className="vtex-checkbox__box absolute top-0 left-0 bottom-0 overflow-hidden w-100 flex items-center align-center justify-center c-on-action-primary"
						style={{ transition: 'right 110ms ease-in-out 30ms' }}
					></div>
				</div>
				<input
					type="checkbox"
					className="vtex-checkbox__input h1 w1 absolute o-0 pointer"
					id="#/properties/message-checkbox-input-true"
					name="#/properties/message"
					value="true"
				/>
			</div>
			<label className="vtex-checkbox__label w-100 c-on-base pointer">{props?.label || 'Checkbox'}</label>
		</div>
	);
};
